import { useParams } from 'react-router-dom';
import { OrderItemStatusGroup, useOrder } from '../../../hooks/useOrder';
import { isItemReturnInProgress } from '../RequestReturnInProgressItems/useReturnInProgressItems';

const isItemEligibleForReturn = (isReturnable: boolean, statusGroup: OrderItemStatusGroup) => {
  if (isReturnable) {
    return true;
  }

  if (statusGroup !== OrderItemStatusGroup.Shipped) {
    return true;
  }

  return false;
};

export const useNonEligibleItems = () => {
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { orderItems = [] } = useOrder(orderNumber);

  return orderItems
    .filter(
      ({ attributes: { isReturnable, statusGroup } }) =>
        !isItemEligibleForReturn(isReturnable, statusGroup)
    )
    .filter(({ attributes: { status } }) => !isItemReturnInProgress(status));
};
